import axios from "axios";
import {api, responseBody} from "./apiBase.service";
import {IAdministrativeEnvelope} from "../../models/Administrative/Administrative";

const report = {
    byIdPdf: (id: string,
           paramId?: string,
           params?: URLSearchParams
    ): Promise<any> => {

        const idParameter = paramId ? `?idParameter=${paramId}` : ''
        return axios.get(`/Report/${id}/pdf${idParameter}`, {params: params})
            .then(responseBody)
    },
    byIdExcel: (id: string,
              paramId?: string,
              params?: URLSearchParams
    ): Promise<any> => {

        const idParameter = paramId ? `?idParameter=${paramId}` : ''
        return axios.get(`/Report/${id}/excel${idParameter}`, {params: params})
            .then(responseBody)
    },
    byIdJson: (id: string,
                paramId?: string,
                params?: URLSearchParams
    ): Promise<any> => {

        const idParameter = paramId ? `?idParameter=${paramId}` : ''
        return axios.get(`/Report/${id}/json${idParameter}`, {params: params})
            .then(responseBody)
    },

    // byIdExcel: (id: string, paramId?: string) => {
    //     const idParameter = paramId ? `?idParameter=${paramId}` : ''
    //     return api.get(`/Report/${id}/excel${idParameter}`)
    // },
    // byIdPdf: (id: string, paramId?: string) => {
    //     const idParameter = paramId ? `?idParameter=${paramId}` : ''
    //     return api.get(`/Report/${id}/pdf${idParameter}`)
    // },
    // byIdJson: (id: string, paramId?: string) => {
    //     const idParameter = paramId ? `?idParameter=${paramId}` : ''
    //     return api.get(`/Report/${id}/json${idParameter}`)
    // },
};

export default report